import React, { useState, useRef } from 'react';
import { enCurrency, enLang } from 'interfaces/IProductData';
import Menu from '@material-ui/core/Menu/Menu';
import { makeStyles } from '@material-ui/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { useObservable } from 'react-use-observable';
import { currencyService } from 'services/CurrencyService';

const useStyles = makeStyles({
  component: {
    '&.chk-config-currency': {
      float: 'right',
      marginRight: '5px',
      '& .chk-config-button': {
        position: 'relative',
        display: 'inline-block',
        padding: '2px 25px 2px 5px',
        border: '1px solid #cecece',
        borderRadius: '4px',
        '& .chk-option-active': {
          marginLeft: '10px',
          fontSize: '12px',
          color: '#232323',
          display: 'inline-block',
          maxWidth: '60px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          height: '21px',
          lineHeight: '28px'
        }
      }
    }
  },

  '@global': {
    '& .currency-menu-item': {
      width: '80px',
      color: '#666',
      fontSize: '.75rem',
      display: 'table',
      '& span': {
        display: 'inlineBlock',
        width: '40px',
        '&.currency': {
          textAlign: 'right'
        }
      }
    }
  }
});
interface IProps {
  circle?: boolean;
}

const options = [{ lang: enLang.PT_BR, currency: enCurrency.BRL, symbol: 'R$' }, { lang: enLang.EN_US, currency: enCurrency.USD, symbol: '$' }];

const ConfigCurrency: React.FC<IProps> = React.memo(props => {
  const [currency] = useObservable(() => currencyService.getCurrency(), []);
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const classes = useStyles({});

  const selectCurrency = (currency: enCurrency) => {
    currencyService.setCurrency(currency);
    setOpen(false);
  };

  if (!currency) {
    return null;
  }

  return (
    <div ref={ref} className={`chk-config-country ${!props.circle ? '' : 'chk-configCountry___avatar'} ${classes.component}`} id="chk-config-country">
      <a id={`chk-selectlang-button-${currency}`} className="chk-config-button" onClick={() => setOpen(true)}>
        <span className="chk-option-active theme-language-bar-selected">{currency}</span>
      </a>

      <Menu id="lock-menu" anchorEl={ref.current} open={open} onClose={() => setOpen(false)}>
        {options.map(option => (
          <MenuItem key={option.currency} selected={currency === option.currency} onClick={() => selectCurrency(option.currency)}>
            <div className="currency-menu-item">
              <span className="currency">
                {option.currency} - {option.symbol}
              </span>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
});

export default ConfigCurrency;
